import { Action } from 'redux';

export interface IConnectState {
  authenticated: boolean;
  user?: IConnectedUser;
}

export interface IConnectedUser {
  first: string;
  last: string;
  roles: UserRoles[];
  username: string;
}

export enum UserRoles {
  Default = 'ROLE_DEFAULT',
  Admin = 'ROLE_ADMIN',
  Viewer = 'ROLE_VIEWER',
}

const connectActionTypes = {
  USER_AUTHENTICATION_SUCCESS: 'USER_AUTHENTICATION_SUCCESS',
  USER_AUTHENTICATION_FAILURE: 'USER_AUTHENTICATION_FAILURE',
};

export interface IAction extends Action {
  type: string;
  payload: {};
}

export type ConnectActions = IAction;

export default connectActionTypes;
